import axios from 'axios';
import { IResponse } from '~/services/api/types';
import {
  IPatientMonitoringPauseCreateDto,
  IPatientMonitoringPauseDto,
  IPatientMonitoringPauseUpdateDto,
} from './types';

const apiUrl = 'patient-monitoring-pauses';

export const create = (
  data: IPatientMonitoringPauseCreateDto,
): IResponse<IPatientMonitoringPauseDto> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
  });

export const update = (
  data: IPatientMonitoringPauseUpdateDto,
): IResponse<IPatientMonitoringPauseDto> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const cancel = (id: number): IResponse<void> =>
  axios({
    method: 'put',
    url: `${apiUrl}/${id}/cancel`,
  });
